import { Link } from 'react-router-dom';

import { BRAND_NAME, SUPPORT_EMAIL } from '../lib/brand';

/** Shared footer: the no-advice disclaimer, legal links, and attribution. */
export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="site-footer-inner">
        <p>
          Sentiment is model-derived analysis of licensed financial news. {BRAND_NAME} does not
          provide investment advice.
        </p>
        <nav className="site-footer-nav" aria-label="Legal">
          <Link className="text-link" to="/privacy">
            Privacy
          </Link>
          <Link className="text-link" to="/terms">
            Terms
          </Link>
          <a className="text-link" href={`mailto:${SUPPORT_EMAIL}`}>
            Contact
          </a>
        </nav>
        <p className="site-footer-fineprint">
          © {new Date().getFullYear()} {BRAND_NAME}. News content © its publishers; follow article
          links for full stories.
        </p>
      </div>
    </footer>
  );
}
